export class JobsFilter {
  constructor() {
    this.jobsFilterToggle = document.querySelector(".jobs-filter__toggle");
    this.toggleableJobsFilterRows = document.querySelectorAll(
      ".jobs-filter__field-row--toggleable"
    );

    this.init();
  }

  init() {
    if (!this.jobsFilterToggle) return;

    this.setupEventListener();
  }

  setupEventListener() {
    this.jobsFilterToggle.addEventListener("click", () => {
      this.handleToggle();
    });
  }

  handleToggle() {
    const isExpanded =
      this.jobsFilterToggle.getAttribute("aria-expanded") === "true";

    if (!isExpanded) {
      this.expandFilter();
    } else {
      this.collapseFilter();
    }
  }

  expandFilter() {
    this.jobsFilterToggle.setAttribute("aria-expanded", "true");

    this.toggleableJobsFilterRows.forEach((row) => {
      row.setAttribute("aria-hidden", "false");
    });
  }

  collapseFilter() {
    this.jobsFilterToggle.setAttribute("aria-expanded", "false");

    this.toggleableJobsFilterRows.forEach((row) => {
      row.setAttribute("aria-hidden", "true");
    });
  }
}
